import { isNil } from 'lodash-es'

const isCoordinate = value => !isNil(value) && value !== ''

const hasCoordinates = coordinates =>
  isCoordinate(coordinates?.latitude) && isCoordinate(coordinates?.longitude)

export default hasCoordinates
